import { createContext, useContext } from 'react';

export const AppContext = createContext({
  company: null,
  user: null,
  jwt: null,
  csrf: null,
  learner: null
});

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};
